import type { DistrictArtAsset } from '../../NumberKingdomDistrictRegistry.js';

const ROOT = 'assets/number-kingdom/addition-citadel/number-forge';

/**
 * Future production registry. These assets are intentionally not added to
 * BootScene until the complete required set exists, preventing 404s and a
 * partially rendered forge from appearing in the shipped route.
 */
export const NUMBER_FORGE_ASSETS = {
  workshopBackground: { key: 'number-forge-workshop-background', path: `${ROOT}/environment/forge-workshop-bg.png`, kind: 'image', required: true },
  workshopForeground: { key: 'number-forge-workshop-foreground', path: `${ROOT}/environment/forge-workshop-foreground.png`, kind: 'image', required: true },
  forgeMachine: { key: 'number-forge-machine', path: `${ROOT}/machine/forge-machine.png`, kind: 'image', required: true },
  forgeMachinePowered: { key: 'number-forge-machine-powered', path: `${ROOT}/machine/forge-machine-powered.png`, kind: 'image', required: true },
  tensPiece: { key: 'number-forge-tens-piece', path: `${ROOT}/manipulatives/tens-piece.png`, kind: 'image', required: true },
  onesPiece: { key: 'number-forge-ones-piece', path: `${ROOT}/manipulatives/ones-piece.png`, kind: 'image', required: true },
  sourceIngot: { key: 'number-forge-source-ingot', path: `${ROOT}/manipulatives/source-ingot.png`, kind: 'image', required: true },
  tensChannel: { key: 'number-forge-tens-channel', path: `${ROOT}/channels/tens-channel.png`, kind: 'image', required: true },
  onesChannel: { key: 'number-forge-ones-channel', path: `${ROOT}/channels/ones-channel.png`, kind: 'image', required: true },
  resultCore: { key: 'number-forge-result-core', path: `${ROOT}/machine/result-core.png`, kind: 'image', required: true },
  missionPanel: { key: 'number-forge-mission-panel', path: `${ROOT}/ui/mission-panel.png`, kind: 'image', required: true },
  chargeButton: { key: 'number-forge-charge-button', path: `${ROOT}/ui/charge-button.png`, kind: 'image', required: true },
  hintButton: { key: 'number-forge-hint-button', path: `${ROOT}/ui/hint-button.png`, kind: 'image', required: true },
  resetButton: { key: 'number-forge-reset-button', path: `${ROOT}/ui/reset-button.png`, kind: 'image', required: true },
  transferTrail: { key: 'number-forge-transfer-trail', path: `${ROOT}/vfx/transfer-trail.png`, kind: 'image', required: true },
  combineBurst: { key: 'number-forge-combine-burst', path: `${ROOT}/vfx/combine-burst.png`, kind: 'image', required: true },
  powerBurst: { key: 'number-forge-power-burst', path: `${ROOT}/vfx/power-burst.png`, kind: 'image', required: true },
} as const satisfies Record<string, DistrictArtAsset>;

export const NUMBER_FORGE_ASSET_LIST = Object.values(NUMBER_FORGE_ASSETS);

export const NUMBER_FORGE_PRODUCTION_GATE = {
  routeEnabled: true,
  reason: 'required-production-art-present',
} as const;

export function getMissingNumberForgeImages(textures: Phaser.Textures.TextureManager) {
  return NUMBER_FORGE_ASSET_LIST.filter(asset => asset.required && !textures.exists(asset.key));
}

/** The production route must remain gated while any required texture is absent. */
export function isNumberForgeProductionReady(textures: Phaser.Textures.TextureManager) {
  return getMissingNumberForgeImages(textures).length === 0;
}

/** Scene/route registration must use this gate, not asset presence alone. */
export function canEnterNumberForge(textures: Phaser.Textures.TextureManager) {
  return NUMBER_FORGE_PRODUCTION_GATE.routeEnabled && isNumberForgeProductionReady(textures);
}
